import React from 'react'
import { Box, Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import TextField from 'presentation/shared/components/TextField'
import {
  EmergencyRoomEditFormikValues,
  UpdateAccompanyingData
} from 'presentation/hospital/layouts/EmergencyRoom/EmergencyRoomDetails/types'
import Heading from 'presentation/shared/components/Heading'
import { phoneMask } from 'presentation/utils/masks'
import Checkbox from 'presentation/shared/components/Checkbox'
import SupportText from 'presentation/shared/components/SupportText'

export function PatientAccompanying() {
  const { values, handleChange, setFieldValue } =
    useFormikContext<EmergencyRoomEditFormikValues>()

  const onCheckBox = (field: keyof UpdateAccompanyingData) => {
    setFieldValue(
      `updateAccompanying.${field}`,
      !values?.updateAccompanying?.[field]
    )
  }

  const defaultProps = {
    placeholder: values.isEditing ? 'Digite aqui...' : '-',
    disabled: !values.isEditing || !values.updateAccompanying?.accompanying_id,
    autoComplete: 'off'
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box mb={1}>
          <Heading color="primary">ACOMPANHANTE/RESPONSÁVEL</Heading>
        </Box>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item xs={12} md={6} lg={4} xl={2}>
          <TextField
            {...defaultProps}
            name={'updateAccompanying.name'}
            onChange={handleChange}
            value={values?.updateAccompanying?.name || ''}
            label="Nome:"
            required
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={2}>
          <TextField
            {...defaultProps}
            name={'updateAccompanying.socialName'}
            onChange={handleChange}
            value={values?.updateAccompanying?.socialName || ''}
            label="Nome Social:"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={2}>
          <TextField
            {...defaultProps}
            name={'updateAccompanying.phone'}
            onChange={handleChange}
            value={values?.updateAccompanying?.phone || ''}
            label="Celular:"
            mask={phoneMask}
            required
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <TextField
            {...defaultProps}
            name={'updateAccompanying.email'}
            onChange={handleChange}
            value={values?.updateAccompanying?.email || ''}
            label="Email:"
            required
          />
        </Grid>
        <Grid container item xs={12} md={6} lg={4} xl={3} spacing={1}>
          <SupportText color="primary">Notificações via</SupportText>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs>
              <Checkbox
                {...defaultProps}
                label={'SMS'}
                onCheck={() => onCheckBox('sendSMS')}
                checked={!!values?.updateAccompanying?.sendSMS}
                labelFor={`updateAccompanying.sendSMS`}
              />
            </Grid>
            <Grid item xs>
              <Checkbox
                {...defaultProps}
                label={'E-mail'}
                onCheck={() => onCheckBox('sendEmail')}
                checked={!!values?.updateAccompanying?.sendEmail}
                labelFor={`updateAccompanying.sendEmail`}
              />
            </Grid>
            <Grid item xs={12}>
              <Checkbox
                {...defaultProps}
                label={'Acompanhante Principal'}
                onCheck={() => onCheckBox('isMain')}
                checked={!!values?.updateAccompanying?.isMain}
                labelFor={`updateAccompanying.isMain`}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
